import { DatePipe } from '@angular/common';
import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { Customer } from 'src/app/models/customer';

@Component({
  selector: 'app-pos-take-photo',
  templateUrl: './pos-take-photo.component.html',
  styleUrls: ['./pos-take-photo.component.sass']
})
export class PosTakePhotoComponent implements OnInit {
  @Input() customer: Customer = new Customer();
  @Output() pictureTakenEmitter:EventEmitter<string> = new EventEmitter();

  @ViewChild('uploadCanvas') uploadCanvas: any;
  @ViewChild('hardwareVideo') hardwareVideo: any;
  @ViewChild('takenCanvas') takenCanvas: any;

  public filename: string = '';
  public picture: string = '';
  public toggleVideoFlag: boolean = false;
  public pictureTaken: boolean = false;

  constructor(private bsModalRef: BsModalRef,private datePipe: DatePipe) { }

  ngOnInit(): void {
  }

  cancel(): void {
    this.bsModalRef.hide();
    this.toggleVideo(false);
  }

  toggleVideo(toggle: boolean, pictureTaken?: boolean) {
    let video = this.hardwareVideo.nativeElement;

    var n = navigator as any;

    n.getUserMedia =
      n.getUserMedia ||
      n.webkitGetUserMedia ||
      n.mozGetUserMedia ||
      n.msGetUserMedia;

    n.mediaDevices.getUserMedia({ video: true }).then(function (stream: any) {
      if (toggle) {
        video.srcObject = stream;
        video.play();
      } else {
        video.srcObject = null;
        video.stop();
      }
    });
    this.toggleVideoFlag = toggle;
    this.pictureTaken = pictureTaken == true;
    // NOTE: For Video + Audio
    // n.mediaDevices.getUserMedia({video: true, audio: true}).then(function(stream) {
    //     video.src = window.URL.createObjectURL(stream);
    //     video.play();
    // });
  }
  public capturePhoto() {
    if (!this.hardwareVideo || !this.toggleVideoFlag) {
      return;
    }
    var context = this.takenCanvas.nativeElement
      .getContext('2d')
      .drawImage(this.hardwareVideo.nativeElement, 0, 0, 640, 480);
    this.picture = this.takenCanvas.nativeElement.toDataURL('image/jpeg');
    this.filename = `${this.customer.code}_${this.datePipe.transform(
      new Date(),
      'YYYYMMDDHHmmSS'
    )}.jpg`;
    this.toggleVideo(false, true);
  }

  public deletePicture() {
    this.picture = '';
    this.toggleVideo(false);
  }

  handleSaveClick():void{
    this.pictureTakenEmitter.emit(this.picture);
    this.pictureTakenEmitter.complete();
    this.cancel();
  }
}
